import { render, staticRenderFns } from "./ShareFinalAssets.vue?vue&type=template&id=5c7e80c3&scoped=true&"
import script from "./ShareFinalAssets.vue?vue&type=script&lang=js&"
export * from "./ShareFinalAssets.vue?vue&type=script&lang=js&"
import style0 from "./ShareFinalAssets.vue?vue&type=style&index=0&id=5c7e80c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c7e80c3",
  null
  
)

export default component.exports